import { render, staticRenderFns } from "./valmistumispyynnon-arviointi.vue?vue&type=template&id=b18b8628&scoped=true&"
import script from "./valmistumispyynnon-arviointi.vue?vue&type=script&lang=ts&"
export * from "./valmistumispyynnon-arviointi.vue?vue&type=script&lang=ts&"
import style0 from "./valmistumispyynnon-arviointi.vue?vue&type=style&index=0&id=b18b8628&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18b8628",
  null
  
)

export default component.exports